// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddWeatherStation_buttonsFooter__jdo7_"};